import { useTranslation } from "react-i18next";
import ConfrimImg from "../../../assets/Icons/modal/confrim.svg";

// PendingModal component
const PendingModal = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center p-4 z-50">
      <div className="bg-white p-6 rounded-lg max-w-md w-full text-center mx-4">
        <img src={ConfrimImg} alt="confrim icon" />
        <h2 className="text-lg font-semibold text-black mb-4">
          {t("Book Pending")}...
        </h2>
        <p className="text-sm text-black">
          {t(
            "You will get a call in a minute from the host or check booked menu for more information"
          )}
        </p>
        <button
          onClick={onClose}
          className="mt-4 bg-blue-500 text-white rounded-lg text-sm py-3 px-20"
          style={{ backgroundColor: "#6938ef" }}
        >
          {t("Done")}
        </button>
      </div>
    </div>
  );
};

export default PendingModal;